export const FEATURE_FLAGS = Object.freeze({
  showIntellifloDepartment: false,
  showFeesPaidDetails: false,
});
